import React, {MouseEventHandler} from "react";

export interface ButtonProps {
    title : string
    color : "default" | "orange" | "green"
    icon? : "young" | "old" | null
    onClick : MouseEventHandler;
}

export default function Button(props : ButtonProps) {
    return <button className={"btn " + props.color + (props.icon !== undefined && props.icon != null ? ' with-icon' : '')} onClick={props.onClick}>
        {props.icon !== undefined && props.icon != null &&
            <img src={"images/shared/" + props.icon + ".png"} alt="" />
        }
        {props.title}
    </button>
}